@let isSmall = small();
@let score = leakScore();

<div class="flex flex-col gap-[0.375rem] items-start">
  <gc-ld-logger-noise-leak-score-gauge
    class="pl-1"
    [status]="leakScoreStatus()"
    [width]="36">
  </gc-ld-logger-noise-leak-score-gauge>

  <div class="flex items-baseline gap-[0.375rem]">
    @if (score === undefined || score === null) {
      <span class="font-bold leading-none text-(--p-primary-500)"
        [ngClass]="isSmall ? 'text-[1rem]' : 'text-[1.25rem]'"
        translate="@@shared-no-data-value-placeholder">
      </span>
    } @else {
      <span class="font-bold leading-none text-(--p-primary-500)"
        [ngClass]="isSmall ? 'text-[1rem]' : 'text-[1.25rem]'"
        translate="@@shared-percentage"
        [translateParams]="{I18N_VAR_VALUE: score}">
      </span>
    }

    <span class="text-[0.6875rem] font-[500] text-(--p-primary-500)"
      [ngClass]="{ '!text-[0.625rem]': isSmall }"
      translate="@@shared-leak-score__text">
    </span>
  </div>
</div>
